import axios from 'axios'

export function request(config) {

    //axiosインスタンスを作る
    const instance = axios.create({
        timeout: 20000,
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    })

    //リクエストのインターセプター
    instance.interceptors.request.use(function (config) {

        //リクエスト送信する前の処理

        config = config.handleRequest(config)

        return config;

    }, function (err) {
        //Do something with request error
        //リクエストを失敗にする

        return Promise.reject(err);
    });

    //レスポンスのインターセプター
    instance.interceptors.response.use(function (res) {

        //受信したデータに対して処理する
        config.handleResponse(res)

        return res;
    }, function (err) {
        //Do something with response error
        //レスポンスを失敗にする

        return Promise.reject(err);
    });

    //処理済みのリクエストを送信する
    return instance(config);
}
